var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-pagination',_vm._g(_vm._b({class:['my-pagination', _vm.$attrs.class],attrs:{"hide-goto-end-buttons":""}},'b-pagination',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }